import FormHeader from "../../../components/shared/form/formHeader";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ContainerDragAndDrop from "../../../components/formularios/dragAndDrop/containerDragAndDrop";
import React, { useState, useEffect } from "react";
import { Button, Grid } from "@material-ui/core";

const CadastrarDuplicarFormulario = (props) => {
  const id = props.match.params.id ? props.match.params.id : null

  const { history } = props;
  const [tituloPagina, setTituloPagina] = useState("Novo Formulário");
  const [subTituloPagina, setSubTituloPagina] = useState(
    "Para iniciar um formulário você precisa selecionar o tipo de campo"
  );

  let dadosFormularioDuplicar = null;

  if (props.location.formularioDuplicar) {
    dadosFormularioDuplicar = props.location.formularioDuplicar;
  }

  useEffect(() => {
    if (dadosFormularioDuplicar) {
      setTituloPagina("Editar Formulário");
      setSubTituloPagina("");
    }
  }, []);

  return (
    <>
      <FormHeader titulo={tituloPagina} subTitulo={subTituloPagina} />
      <Grid style={{ marginTop: 180, padding: "0 24px" }}>
        <DndProvider backend={HTML5Backend}>
          <ContainerDragAndDrop
            formularioDuplicar={dadosFormularioDuplicar}
            history={history}
          />
        </DndProvider>
      </Grid>
    </>
  );
};

export default CadastrarDuplicarFormulario;
